import Swiper, { Lazy, Navigation, Pagination } from "swiper";

const Home = {
  init() {
    Home.heroSlider();
    Home.partnersSlider();
  },

  heroSlider() {
    const heroEl = $(".hero");
    if (heroEl.length) {
      new Swiper(heroEl.find(".hero-slider")[0], {
        modules: [Lazy, Pagination],
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
        effect: "fade",
        pagination: {
          el: heroEl.find(".swiper-pagination")[0],
          bulletElement: "button",
          clickable: true,
        },
      });
    }
  },

  partnersSlider() {
    const partnersEl = $(".partners");
    if (partnersEl.length) {
      const navPrev = partnersEl.find(".swiper-button-prev");
      const navNext = partnersEl.find(".swiper-button-next");

      new Swiper(partnersEl.find(".partners-slider")[0], {
        modules: [Lazy, Navigation],
        spaceBetween: 0,
        loop: true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 4,
        },
        navigation: {
          prevEl: navPrev[0],
          nextEl: navNext[0],
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          400: {
            slidesPerView: 2,
          },
          600: {
            slidesPerView: 2,
          },
          900: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 3,
          },
        },
      });
    }
  },
};

export default Home;
